function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @summary SDK
 * @memberOf SDK
 */
var QualifierValue = /*#__PURE__*/function () {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  function QualifierValue(qualifierValue) {
    _classCallCheck(this, QualifierValue);

    this.values = [];
    this.delimiter = ':'; // {value}{delimiter}{value}...

    if (this.hasValue(qualifierValue)) {
      this.addValue(qualifierValue);
    }
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */


  _createClass(QualifierValue, [{
    key: "toString",
    value: function toString() {
      return this.values.join(this.delimiter);
    }
    /**
     * @description Checks if the provided argument has a value
     * @param {any} v
     * @private
     * @return {boolean}
     */

  }, {
    key: "hasValue",
    value: function hasValue(v) {
      return typeof v !== 'undefined' && v !== null && v !== '';
    }
    /**
     * @desc Adds a value for the this qualifier instance
     * @param {any} value
     * @return {this}
     */

  }, {
    key: "addValue",
    value: function addValue(value) {
      var _this = this;

      // Append value or array of values
      if (Array.isArray(value)) {
        this.values = this.values.concat(value);
      } else {
        this.values.push(value);
      } // Remove falsy values


      this.values = this.values.filter(function (v) {
        return _this.hasValue(v);
      });
      return this;
    }
    /**
     * @description Sets the delimiter for this instance
     * @param delimiter
     */

  }, {
    key: "setDelimiter",
    value: function setDelimiter(delimiter) {
      this.delimiter = delimiter;
      return this;
    }
  }]);

  return QualifierValue;
}();

export { QualifierValue };